import { Ope } from "./Ope";
import { PostionCoordinate } from "./PositionCoordinate";

export class Coordinates {

    position: PostionCoordinate;    
    title: string;    
    urlImage: string;
    adress: string;
    ope!: Ope;
    constructor (position: PostionCoordinate,    title: string,    urlImage: string, address: string, ope: Ope){
        this.position = position;
        this.urlImage = urlImage;
        this.title = title;
        this.adress = address;
        this.ope = ope;
    };

    

}